import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.273 4.586H2.728C1.181 4.586 0 5.733 0 7.233v9.706c0 1.5 1.182 2.647 2.727 2.647h14.546c1.545 0 2.727-1.147 2.727-2.647V7.233c0-1.5-1.182-2.647-2.727-2.647M18 16.74c0 .507-.355.846-.889.846H2.89c-.533 0-.889-.339-.889-.846V7.432c0-.508.356-.846.889-.846h14.22c.534 0 .889.338.889.846zM14.657.293a1 1 0 0 1 0 1.414l-2.879 2.879H10l.182-1.232 3.06-3.061a1 1 0 0 1 1.415 0m-8.95 0a1 1 0 0 0 0 1.414L8.5 4.586H10l.182-1.232L7.122.293a1 1 0 0 0-1.415 0M11 15.586a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }, null, -1)
  ]))]))
}
export default { render: render }